package kz.dentalcrm.app.screens.splash.mvi

import kz.dentalcrm.app.core.base.ViewEvent

sealed interface SplashViewEvent : ViewEvent {
    data object CheckAuth : SplashViewEvent
}
